<template>
  <div >
    <v-app-bar app clipped-right id="app-width" elevation="8">
      <v-toolbar-items class="pt-2">
        <router-link to="/">
          <img :src="logo" style="max-height: 50px;">
        </router-link>
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <template v-if="$vuetify.breakpoint.mdAndUp">
        <SearchIses/>
        <v-spacer></v-spacer>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn color="accent" dark text v-on="on">
              Ejes
              <v-icon>keyboard_arrow_down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              row
              wrap
              align-left
              class="pl-0"
              v-for="(axis, index) in axes"
              :key="index"
              @click="goToSelectedAxis(axis)"
              :disabled="disabledAxisRoute(axis.slug)"
            > 
              <v-list-item-title class="text-center text-uppercase">
                {{axis.nombre_corto || axis.nombre}}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn color="accent" dark text href="https://medium.com/@observatorio.onigies">
          Blog
        </v-btn>        
      </template>
      <v-app-bar-nav-icon v-else @click="menu = !menu"></v-app-bar-nav-icon>
    </v-app-bar>
    <v-navigation-drawer v-model="menu" clipped app right v-if="$vuetify.breakpoint.smAndDown">
      <v-list-item
        row
        wrap
        align-left
        active-class="yeeko-text"
        class="pl-0"
      >
        <!-- <v-list-item-action/> -->
        <v-list-item-title class="text-left">
          <SearchIses/>
        </v-list-item-title>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item
        row
        wrap
        align-left
        class="pr-0 pl-0"
      >
        <v-list-item-title class="text-left text-uppercase">
          <v-btn color="accent" 
                 text block large
                 v-text="'Blog'"
                 href="https://medium.com/@observatorio.onigies"/>
        </v-list-item-title>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-group
        :append="true"
        color="red"
        value="true"
      >
        <template v-slot:activator>
          <v-list-item
            row
            wrap
            align-left
            class="pr-0 pl-3"
          >
            <v-list-item-title class="text-left grey--text">
              Ejes:
            </v-list-item-title>
          </v-list-item>
        </template>
        <v-list-item
          row
          wrap
          align-left
          class="pl-0"
          v-for="(axis, index) in real_axes"
          :key="index"
          @click="goToSelectedAxis(axis)"
          :disabled="disabledAxisRoute(axis.slug)"
        > 
          <v-list-item-title  class="text-left text-uppercase mx-4 pointer">
            <span class="">{{axis.nombre_corto || axis.nombre}}</span>
          </v-list-item-title>
        </v-list-item>
      </v-list-group>
    </v-navigation-drawer>
  </div>
</template>

<script>
import AxesOptions from "./axesoptions.js"
import SearchIses from "../components/home/common/SearchIses"
import { mapState, } from "vuex";

export default {
  name:"mainMenu",
  components: {
    SearchIses,
  },  
  data() {
    return {
      logo: require("@/assets/onigies.png"),
      menu: false,
      selected_ies: undefined,
      axes_prov: AxesOptions,
    }
  },

  methods: {
    goToSelectedAxis({slug}) {
      this.$router.push({ path: `/eje/${slug}`})
    },
    disabledAxisRoute(axis_route) {
      return this.$router.currentRoute['params']['eje_id'] === axis_route
    }
  },
  computed:{
    ...mapState({
      ises: state => state.ises,
      axes: state => state.ejes,
    }),
    real_axes(){
      return this.axes || this.axes_prov
    }
  },


}
</script>
<style lang="scss">
  #app-width{
    margin: auto;
    width: 1275px;
  }
</style>